<div class="about-header-background"></div>
<div class="container p-5">
    <div class="row">
        <div class="w-100">
            <h2>About</h2>
        </div>
        <div class="w-100 py-5">
            <h5>
                <strong>
                    The Open European Location Services (ELS) project is developing European open geospatial data
                    services from official national sources.
                </strong>
            </h5>
        </div>
        <div class="w-100">
            <div class="row">
                <div class="col-md-6">
                    <p>
                        EuroGeographics, which represents Europe’s National Mapping, Cadastral and Land Registration
                        Authorities, is coordinating the two-year initiative co-financed by the European Union’s
                        Connecting Europe Facility. The international not-for-profit association is working with
                        partners from member organisations in Finland, Germany, Great Britain, Norway, Poland, Spain,
                        Sweden and The Netherlands.
                    </p>
                    <p>
                        <a href="https://openels.eu/">The Open ELS Project</a> demonstrates the potential of a single
                        access point for harmonised,pan-European, authoritative geospatial information and services.
                        It is a first step in making high-value open geospatial data from official national sources
                        available in support of the wider digital economy. Activities are focused on facilitating
                        access to, and encouraging the take up and use of this information, and are strongly user
                        orientated with a comprehensive programme of activities for SMEs.
                    </p>
                </div>
                <div class="col-md-6">
                    <p>
                        As well as the test services accessible through this user interface, the Project has also
                        developed an open data policy to create a common basis for licensing that respects the
                        different national policy, legislative and business models across Europe. As well as the
                        test services accessible through this user interface, the Project has also developed an open
                        data policy to create a common basis for licensing that respects the different national policy,
                        legislative and business models across Europe.
                    </p>
                    <p>
                        For more information on the Project, visit <a href="https://openels.eu/">https://openels.eu/</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
